/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestSynthetixExchanger extends Contract<ITestSynthetixExchanger> {
  getAmountsForExchange: Call<(_sourceAmount: BigNumberish, _sourceCurrencyKey: BytesLike, _destinationCurrencyKey: BytesLike) => { amountReceived_: BigNumber, fee_: BigNumber, exchangeRate_: BigNumber }, ITestSynthetixExchanger>
  'getAmountsForExchange(uint256,bytes32,bytes32)': Call<(_sourceAmount: BigNumberish, _sourceCurrencyKey: BytesLike, _destinationCurrencyKey: BytesLike) => { amountReceived_: BigNumber, fee_: BigNumber, exchangeRate_: BigNumber }, ITestSynthetixExchanger>
}

let ITestSynthetixExchangerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestSynthetixExchangerBytecode = '0x';
}

// prettier-ignore
export const ITestSynthetixExchanger = contract<ITestSynthetixExchanger>(ITestSynthetixExchangerBytecode)`
  function getAmountsForExchange(uint256 _sourceAmount, bytes32 _sourceCurrencyKey, bytes32 _destinationCurrencyKey) view returns (uint256 amountReceived_, uint256 fee_, uint256 exchangeRate_)
`;